import { isEmpty } from 'lodash';

import { DECODING_ONLINE, WR } from '../../constants/measure';
import { ERROR_STATUS, LANTERN_ERROR_CODES } from '../../constants/error';
import { apiCallFailed, noticeApiError } from './apiCallActions';

import selectors from '../../rootSelectors';
import { makeApiPatchRequest, makeApiPostRequest, makeApiGetRequest } from './apiActions';
import { setNextResumeResultItem } from '../resume/resumeResultActions';
import { setResult } from './resultActions';
import DecServiceClient from '../clients/DecServiceClient';

export const saveResultResponse = (
    resultId,
    formId,
    measure,
    response,
    isComplete = false,
) => async (dispatch, getStore) => {
    const patchData = {
        student_uid: selectors.getUserId(getStore()),
        item_level_details: {
            responses: [response],
        },
    };

    const endpoint = DecServiceClient.constructResultEndpoint(resultId);
    await dispatch(makeApiPatchRequest(endpoint, patchData));

    // Reset resume result next item because it's no longer accurate after
    // we make change to the result.
    dispatch(setNextResumeResultItem(resultId));

    // result status should be updated if completeness has changed
    if (isComplete) {
        dispatch(setResult({
            result_id: resultId,
            is_complete: isComplete,
            form_id: formId,
            measure,
        }));
    }

    return isComplete;
};

export const createResult = (measure, formId) => async (dispatch, getStore) => {
    const state = getStore();
    const instId = selectors.getInstId(state, WR.MEASURE);

    const postBody = {
        assessment: DECODING_ONLINE.ASSESSMENT,
        assessment_mode: 'online',
        form_id: formId,
        grade_level: selectors.getGrade(state),
        inst_uid: selectors.getInstId(state, measure),
        period: selectors.getToy(state),
        student_uid: selectors.getUserId(state),
        student_temporal_id: selectors.getStudentTemporalId(state, instId) || undefined,  // unset if not available
        school_year: selectors.getSchoolYear(state),
        measure,
    };

    const endpoint = DecServiceClient.constructResultListEndpoint();
    const resultJson = await dispatch(makeApiPostRequest(endpoint, postBody));

    dispatch(setResult(resultJson));

    return resultJson.result_id;
};

export const fetchStudentResults = () => async (dispatch, getStore) => {
    const state = getStore();

    const config = {
        studentId: selectors.getUserId(state),
        grade: selectors.getGrade(state),
        period: selectors.getToy(state),
        schoolYear: selectors.getSchoolYear(state),
    };

    const endpoint = DecServiceClient.constructResultListEndpoint(config);
    const data = await dispatch(makeApiGetRequest(endpoint));

    const resultsData = isEmpty(data) ? [] : data;
    resultsData.forEach((resultData) => dispatch(setResult(resultData)));
};

export const saveMeasureResponse = (
    measure,
    formId,
    response,
    isComplete = false,
) => async (dispatch, getStore) => {
    const state = getStore();

    const result = selectors.findResultFor(state, {
        measure,
        formId,
        isComplete: false,
    });

    const resultId = result
        ? result.id
        : await dispatch(createResult(measure, formId));

    return dispatch(saveResultResponse(
        resultId, formId, measure, response, isComplete,
    ));
};

export const fetchContent = (measure, retryActionName) => async (dispatch, getStore) => {
    const state = getStore();
    const period = selectors.getToy(state);
    const grade = selectors.getGrade(state);
    return dispatch(DecServiceClient.getForm(period, grade, measure, null, retryActionName))
        .then(contentJson => contentJson instanceof Array ? contentJson[0] : contentJson,
            () => {
                dispatch(noticeApiError(
                    ERROR_STATUS.NO_FORM_CONTENT,
                    LANTERN_ERROR_CODES.NO_FORM_CONTENT,
                    measure,
                ));
                dispatch(apiCallFailed(
                    undefined,
                    undefined,
                    ERROR_STATUS.NO_FORM_CONTENT,
                    LANTERN_ERROR_CODES.NO_FORM_CONTENT,
                ));
            });
};
